import axios from "axios";
import { postRequest } from "./utils/apiUtils";

export const getPreSignedUrl = async (pdf) => {
    await postRequest({ url: `api/get_presigned_url`, payload: { url: pdf }}).then((response) => {
      const { data } = response;
      if(data.success){
        window.open(data.result, '_blank')
      }
    }).catch((error) => {
        console.log(error)
    })
  }


// WEBPACK FOOTER //
// ./src/utils.js